import { createContext, useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { adjustColor } from '../utils/colorUtils';

export const ThemeContext = createContext();

export function ThemeProvider({ children }) {
	// Initialize dark mode state based on localStorage
	const [isDarkMode, setIsDarkMode] = useState(() => {
		const savedTheme = localStorage.getItem('theme');
		return savedTheme === 'light' ? false : true;
	});

	// Get organization data for colors
	const { orgData } = useAuth();

	useEffect(() => {
		// Sync dark mode with localStorage
		localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
	}, [isDarkMode]);

	useEffect(() => {
		if (orgData) {
			// Set primary color (for backgrounds)
			document.documentElement.style.setProperty(
				'--primary-color',
				orgData.primaryColor
			);
			document.documentElement.style.setProperty(
				'--primary-color-hover',
				adjustColor(orgData.primaryColor, -10)
			);
			document.documentElement.style.setProperty(
				'--primary-color-light',
				`${orgData.primaryColor}1A`
			);

			// Set secondary color (for text/buttons)
			document.documentElement.style.setProperty(
				'--secondary-color',
				orgData.secondaryColor
			);
			document.documentElement.style.setProperty(
				'--secondary-color-hover',
				adjustColor(orgData.secondaryColor, -10)
			);

			// Set accent color (for highlights)
			document.documentElement.style.setProperty(
				'--accent-color',
				orgData.accentColor
			);
			document.documentElement.style.setProperty(
				'--accent-color-light',
				`${orgData.accentColor}1A`
			);
		}
	}, [orgData]);

	const toggleTheme = () => {
		setIsDarkMode(!isDarkMode);
	};

	return (
		<ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
			{children}
		</ThemeContext.Provider>
	);
}
